exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".studio .label{font-size:.75rem;font-style:normal}", ""]);

// exports
